import React from 'react';
import { useParams } from 'react-router-dom';
import { usePackingList } from '../../queries/packingListQueries';
import PKLDownload from '../../components/packing_list/PKLDownload';
import SwanDownload from '../../components/packing_list/SwanDownload';

const PKLDownloadPage = () => {
    const { id } = useParams();
    const { data: pklData, isLoading, isError } = usePackingList(id);

    if (isLoading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center bg-light" style={{ height: "100vh", width: "100vw" }}>
                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h6 className="mt-3 text-muted fw-semibold">Loading report details...</h6>
            </div>
        );
    }

    if (isError || !pklData) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center bg-light" style={{ height: "100vh", width: "100vw" }}>
                <div className="alert alert-danger">Error loading report details. Please try again.</div>
            </div>
        );
    }

    // Check item category: Sawn sizes vs Round logs
    const isSawnSize = pklData.item === "TEAK SAWN SIZE" || pklData.item === "TEAK SAWN SIZES";

    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            {isSawnSize ? (
                <SwanDownload pklData={pklData} />
            ) : (
                <PKLDownload pklData={pklData} />
            )}
        </div>
    );
};

export default PKLDownloadPage;
